export const argumentativeTextRubrics = [
	{
		name: "Argumenterande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Två argument med enkla bevis 2) Försöker bemöta motargument 3) Använder egna erfarenheter som bevis 4) Hänvisar till någon källa",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Ett utvecklat argument med bevis 2) Använder egna erfarenheter 3) Nämner någon källa",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett enkelt argument 2) Försöker ge bevis 3) Berättar vad man tycker",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga argument 2) Bevis 3) Egna åsikter",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder känslor och fakta för att övertyga 2) Enkla språkliga tekniker 3) Tänker på vem som ska läsa 4) Ställer frågor till läsaren",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder känslor eller fakta 2) Försöker övertyga läsaren 3) Visar hänsyn till läsaren",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker påverka läsaren 2) Visar egna känslor 3) Talar till läsaren",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Försök att övertyga 2) Kontakt med läsaren 3) Engagemang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig åsikt i början 2) Tre utvecklade stycken 3) Slut som upprepar åsikten 4) Stycken som hänger ihop",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Åsikt i början 2) Två-tre stycken 3) Ett tydligt slut 4) Försök till styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) En början med åsikt 2) Minst två stycken 3) Ett slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig åsikt 2) Stycken 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydligt och enkelt språk 2) Använder 'eftersom' och 'därför' 3) Vårdade formuleringar 4) Stor bokstav och punkt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Begripligt språk 2) Några bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Går att förstå 2) Försöker med bindeord 3) Mestadels läsbart",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förståeligt språk 2) Bindeord 3) Läsbarhet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre argument med bevis 2) Enkla motargument bemöts 3) Använder fakta och erfarenheter 4) Nämner källor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två argument med bevis 2) Använder fakta eller erfarenheter 3) Någon källa nämns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett utvecklat argument 2) Försöker ge bevis 3) Någon egen erfarenhet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Bevis 3) Fakta eller erfarenheter",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Blandar känslor och fakta 2) Flera språkliga tekniker 3) Anpassar till läsaren 4) Använder retoriska frågor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder känslor och fakta 2) Någon språklig teknik 3) Tänker på läsaren",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker övertyga 2) Visar känslor 3) Talar till läsaren",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Övertygande kraft 2) Läsarkontakt 3) Engagemang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig åsikt i början 2) Fyra utvecklade stycken 3) Starkt slut 4) Logisk styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Åsikt i början 2) Tre stycken 3) Tydligt slut 4) Styckeindelning finns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Början med åsikt 2) Två-tre stycken 3) Ett slut",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig åsikt 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydligt och varierat språk 2) Flera bindeord 3) Bra formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Vanliga bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripligt språk 2) Några bindeord 3) Mestadels rätt stavat",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Korrekt stavning",
					},
				],
			},
		],
	},

	{
		name: "Argumenterande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tre-fyra argument med bevis 2) Bemöter motargument 3) Fakta och exempel används 4) Flera olika källor används",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre argument med bevis 2) Nämner motargument 3) Använder någon källa",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två argument med enkla bevis 2) Försöker använda fakta 3) Någon källa nämns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Bevis 3) Källor",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder både känsla och förnuft 2) Flera språkliga tekniker 3) Anpassar till målgrupp 4) Effektiva retoriska frågor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder känsla eller förnuft 2) Någon språklig teknik 3) Tänker på målgrupp",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker övertyga 2) Enkel språklig teknik 3) Viss målgruppsanpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Övertygande element 2) Språkliga tekniker 3) Målgruppsanpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig tes i början 2) Fyra-fem utvecklade stycken 3) Övertygande slut 4) Genomtänkt styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tes i början 2) Tre-fyra stycken 3) Bra slut 4) Styckeindelning finns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel tes 2) Tre stycken 3) Ett slut finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tes 2) Styckeindelning 3) Tydligt slut",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat och tydligt språk 2) Flera bindeord 3) Bra formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Vanliga bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Några bindeord 3) Begriplig text",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Läsbarhet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fyra välgrundade argument 2) Bemöter motargument effektivt 3) Relevant fakta och statistik 4) Källor värderas",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre argument med bevis 2) Nämner motargument 3) Använder källor",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två argument med bevis 2) Försöker med källor 3) Enkel argumentation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga argument 2) Bevis 3) Källor",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Medveten användning av ethos/logos/pathos 2) Flera retoriska tekniker 3) Tydlig målgruppsanpassning 4) Effektiva språkliga verktyg",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder olika övertalningssätt 2) Någon retorisk teknik 3) Viss målgruppsanpassning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker övertyga 2) Enkel retorisk teknik 3) Tänker på läsaren",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Övertalningsförsök 2) Retoriska tekniker 3) Läsaranpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv inledning med tydlig tes 2) Fem utvecklade stycken 3) Slagkraftigt slut 4) Logisk styckeföljd",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra inledning med tes 2) Fyra stycken 3) Tydligt slut 4) Fungerande stycken",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Inledning med tes 2) Tre stycken 3) Avslutning finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig tes 2) Styckeindelning 3) Avslutning",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Övertygande och varierat språk 2) Många bindeord 3) Träffsäkra formuleringar 4) Korrekt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Flera bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Några bindeord 3) Oftast korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fem övertygande argument 2) Utvecklade motargument bemöts 3) Relevant och aktuell fakta 4) Källor granskas kritiskt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tre-fyra argument med bevis 2) Bemöter motargument 3) Källor används",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Två-tre argument med bevis 2) Nämner källor 3) Enkel argumentation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Källor 3) Bevis",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Balanserad användning av ethos/logos/pathos 2) Avancerade retoriska tekniker 3) Genomtänkt målgruppsanpassning 4) Effektiv argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder retoriska verktyg 2) Flera tekniker 3) Anpassar till målgrupp",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Något retoriskt verktyg 2) Enkel teknik 3) Viss målgruppsanpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retoriska verktyg 2) Tekniker 3) Målgruppsanpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stark inledning med tydlig tes 2) Sex välutvecklade stycken 3) Övertygande slutsats 4) Genomtänkt disposition",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra inledning och tes 2) Fyra-fem stycken 3) Tydlig slutsats 4) Logisk disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Inledning med tes 2) Tre-fyra stycken 3) Enkel slutsats",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig tes 2) Styckeindelning 3) Slutsats",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och övertygande språk 2) Avancerade bindeord 3) Effektiva formuleringar 4) Korrekt och varierat språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Flera bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Vanliga bindeord 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Flera övertygande argument med starka bevis 2) Motargument bemöts skickligt 3) Relevant fakta och statistik används 4) Källkritisk hantering av information",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre utvecklade argument med bevis 2) Motargument nämns 3) Fakta används för att stödja argumenten",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett utvecklat argument med bevis 2) Försök att använda fakta 3) Enkel argumentation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Bevis för påståenden 3) Faktaunderlag",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv användning av ethos, logos och pathos 2) Övertygande språkliga tekniker 3) Anpassar stil efter målgrupp 4) Retoriska frågor används skickligt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder minst två retoriska verktyg 2) Anpassar delvis efter målgrupp 3) Försöker övertyga med olika tekniker",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Använder något retoriskt verktyg 2) Viss medvetenhet om målgrupp 3) Försöker påverka läsaren",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retoriska verktyg 2) Målgruppsanpassning 3) Försök att övertyga",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fängslande inledning med tydlig tes 2) Logisk uppbyggnad av argument 3) Slagkraftig avslutning 4) Effektiv styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig tes i inledningen 2) 3-4 utvecklade stycken 3) Sammanfattande avslutning 4) Fungerande styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tes finns 2) Minst 3 stycken 3) Enkel avslutning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig tes 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Övertygande och formellt språk 2) Varierade argumenterande bindeord 3) Precisa formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt och sakligt språk 2) Argumenterande bindeord används 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripligt språk 2) Några bindeord 3) Läsbar text",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Läsbarhet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sex välgrundade argument 2) Motargument analyseras och bemöts 3) Omfattande faktaunderlag 4) Kritisk källgranskning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fyra-fem argument med bevis 2) Bemöter motargument 3) Källor används och värderas",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tre argument med bevis 2) Källor används 3) Enkel argumentation",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Källor 3) Bevisföring",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerad användning av ethos/logos/pathos 2) Sofistikerade retoriska tekniker 3) Skicklig målgruppsanpassning 4) Övertygande argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder alla retoriska verktyg 2) Flera tekniker 3) God målgruppsanpassning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några retoriska verktyg 2) Enkel teknik 3) Viss målgruppsanpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retoriska verktyg 2) Tekniker 3) Målgruppsanpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Kraftfull inledning med välformulerad tes 2) Sex-sju välutvecklade stycken 3) Övertygande slutsats 4) Sofistikerad disposition",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Stark inledning och tes 2) Fem-sex stycken 3) Tydlig slutsats 4) Genomtänkt disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Inledning med tes 2) Fyra stycken 3) Slutsats finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig tes 2) Styckeindelning 3) Slutsats",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Exakt och nyanserat språk 2) Avancerade bindeord 3) Retoriskt effektiva formuleringar 4) Fullt korrekt språkhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Precist språk 2) Varierade bindeord 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Grundläggande bindeord 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Bindeord 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sju genomarbetade argument 2) Djupgående analys av motargument 3) Omfattande forskningsbaserat underlag 4) Avancerad källkritisk diskussion",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fem-sex argument med bevis 2) Analyserar motargument 3) Forskningsbaserade källor används",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fyra argument med bevis 2) Källor används 3) Grundläggande analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade argument 2) Trovärdiga källor 3) Analys",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex integration av ethos/logos/pathos 2) Avancerade stilfigurer 3) Strategisk målgruppsanpassning 4) Sofistikerad argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Medveten retorisk strategi 2) Flera stilfigurer 3) Tydlig målgruppsanpassning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande retorik 2) Några stilfigurer 3) Viss målgruppsanpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retorisk medvetenhet 2) Stilfigurer 3) Målgruppsanpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektfull inledning med problematiserande tes 2) Sju-åtta sammanhängande stycken 3) Nyanserad slutsats 4) Avancerad disposition",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad inledning och tes 2) Sex stycken 3) Välgrundad slutsats 4) Genomtänkt disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig inledning och tes 2) Fem stycken 3) Relevant slutsats",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fungerande tes 2) Logisk styckeindelning 3) Relevant slutsats",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Akademiskt och precist språk 2) Avancerade konnektorer 3) Effektfulla formuleringar 4) Helt korrekt språkhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Formellt språk 2) Varierade konnektorer 3) Få formella fel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Grundläggande konnektorer 3) Acceptabel korrekthet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Formellt språk 2) Konnektorer 3) Språklig korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Åtta nyanserade argument 2) Kritisk utvärdering av motargument 3) Vetenskapligt underbyggt resonemang 4) Självständig källkritisk analys",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sex-sju argument med bevis 2) Diskuterar motargument 3) Vetenskapliga källor används",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fem argument med bevis 2) Trovärdiga källor 3) Viss analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Underbyggda argument 2) Vetenskapliga källor 3) Analys",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Strategisk användning av retoriska verktyg 2) Komplexa stilfigurer 3) Sofistikerad målgruppsanpassning 4) Övertygande argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Effektiv retorik 2) Utvecklade stilfigurer 3) God målgruppsanpassning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande retorik 2) Enkla stilfigurer 3) Viss anpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retorisk strategi 2) Stilfigurer 3) Anpassning",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex problematisering i inledningen 2) Åtta-nio välstrukturerade stycken 3) Djupgående slutsats 4) Retoriskt effektiv disposition",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Problematiserande inledning 2) Sju stycken 3) Analyserande slutsats 4) Logisk disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklad inledning 2) Sex stycken 3) Tydlig slutsats",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Problematisering 2) Struktur 3) Slutsats",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskapligt och nyanserat språk 2) Avancerade akademiska konnektorer 3) Retoriskt träffsäkra formuleringar 4) Stilistisk säkerhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Varierade konnektorer 3) God språkhantering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Formellt språk 2) Fungerande konnektorer 3) Acceptabel korrekthet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Akademiskt språk 2) Konnektorer 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Argumenterande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Argumentation och bevisföring",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Nio-tio välunderbyggda argument 2) Systematisk analys av motargument 3) Omfattande vetenskapligt stöd 4) Avancerad forskningsanknytning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Sju-åtta argument med bevis 2) Analyserar motargument 3) Vetenskaplig grund",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sex argument med bevis 2) Vetenskapliga källor 3) Grundläggande analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Vetenskapliga argument 2) Forskningsanknytning 3) Analys",
					},
				],
			},
			{
				name: "Retoriska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerad retorisk argumentation 2) Komplexa stilistiska verktyg 3) Sofistikerad publikanalys 4) Övertygande vetenskaplig ton",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad retorik 2) Flera stilistiska verktyg 3) God publikanalys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande retorik 2) Några stilistiska verktyg 3) Viss publikanalys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Retorisk medvetenhet 2) Stilistiska verktyg 3) Publikanalys",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Akademisk problematisering i inledningen 2) Tio välstrukturerade stycken 3) Vetenskaplig slutsats 4) Komplex disposition",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad problematisering 2) Åtta stycken 3) Analytisk slutsats 4) Genomtänkt disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande problematisering 2) Sju stycken 3) Tydlig slutsats",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Problematisering 2) Vetenskaplig struktur 3) Analytisk slutsats",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerat akademiskt språk 2) Vetenskapliga konnektorer 3) Precisa formuleringar 4) Fullständig språklig säkerhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Vetenskapligt språk 2) Akademiska konnektorer 3) God precision",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Grundläggande konnektorer 3) Acceptabel precision",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Vetenskapligt språk 2) Akademiska konnektorer 3) Precision",
					},
				],
			},
		],
	},
];
